import { object, array, number, string } from 'superstruct';

export const messagingConfigSchema = object({
  maxFileSize: number(),
  allowedFileTypes: string(),
  allowedFileTypesErrorList: string(),
  allowedImageTypes: array(string()),
  messageInputCharacterLength: number(),
});
